import { makeModuleI18nSelector } from "@client/content/selectors";
import { type ControlFormField } from "@client/controls/Form/component";
import TextInput from "@client/controls/Inputs/TextInput/component";
import { createSelector } from "reselect";
import { makeLocalStateFieldErrorsSelector } from "../selectors";

export const makeFieldsSelector = () => {
  const fieldErrorsSelector = makeLocalStateFieldErrorsSelector();
  const i18nSelector = makeModuleI18nSelector();

  return createSelector([i18nSelector, fieldErrorsSelector], (i18n, fieldErrors) => {
    const fields: ControlFormField[] = [
      {
        label: i18n.newPassword,
        Component: TextInput,
        name: "password",
        componentOpts: { type: "password" },
        isRequired: true,
        defaultValue: ""
      },
      {
        label: i18n.repeatPassword,
        Component: TextInput,
        name: "repeatPassword",
        componentOpts: { type: "password" },
        isRequired: true,
        defaultValue: ""
      }
    ];

    fields.forEach((f) => {
      f.error = fieldErrors[f.name] ?? undefined;
    });

    return fields;
  });
};
